import { Map as immutable } from 'immutable';
import {INLPHighlightConfig} from '@ispm-client/modules/file-module/Interfaces';

export interface IEventsDefAndSelectedState {
  eventsDefinition: immutable<string, IEventDefinition>;
  selectedEvent: IEvent;
  eventsData: immutable<string, IEvent>;
  timelineSelectedEvent: IEvent;
  discardEventTabData: boolean;
  viewWizard: boolean;
}

export interface ITimelineConfig {
  width?: string;
  height?: string;
  startSpan: string;
  endSpan: string;
  cssClass?: string;
  showNavIcons?: boolean;
  showExtended?: boolean;
  showEventFilter?: boolean;
  queryParams?: any;
  alignRight?: boolean;
}


export interface IEventDefinition {
  id: string;
  name: string;
  context: any;
  resourceType: string;
  ui: {
    timeline: ITimelineEventConfig;
    eventPanel?: any;
    formsConfig?: any;
    group?: {
      code: string;
      display: string;
      iconName?: string;
    };
    enableSaveButtonBasedOnDataChange?: any;
    reValidateNotification?:any;
    isEventViewerEditable?: boolean
  };
  common?: {
    formsConfig: any;
  };
  backend?: {
    includeInTimeline?: boolean;
    formsConfig: any;
  };
}

export interface ITimelineEventConfig {
  markerIcon?: string;
  markerType?: TimelineMarkerType | string;
  fill?: TimelineMarkerFill | string;
  fillColor?: string;
  dateFormat?: string;
  tooltipShow?: boolean;
  popover?: boolean;
  width?: string;
  markerWidth?: string;
  iconColor?: string;
  cssClass?: string;
  category?: string;
  groupLabel?: string;
  minimalFormId?: string;
}

export interface IEvent {
  id: string;
  resourceType?: string;
  context?: any[];
  category: {
    code: string;
    display: string;
  };
  date: string;
  conclusion: string;
  source: string;
  label: string;
  content: Array<any>;
  approved?: boolean;
  group?: any;
  archived?: boolean;
  performed?: string;
  isCopied?: boolean;
  lastCopiedDateTime?: string;
  selected: boolean;
  isExternalUpdate?: boolean;
  client_defined_identifier?: any;
}

export interface IQueryParam {
  queryString: string;
  identifier: string;
  identifierType: string;
  targetResource: string;
}

export interface IEventMapParam {
  eventBasedOnDataChange: boolean;
  exclusionKeys?: string[];
  sortOrder? : string[];
  groupMapping?: {
    associationKey: string;
    modificationKey: string
  };

}

export interface IEventManagerConfig {
  upload: {
    fileOptions: any;
  };
  create: {
    formId: string;
  };
  rightPanel: {
    width: string;
  };
  middlePanel: {
    width: string;
  };
  showEventsGroup:boolean;
  showValidate: boolean;
  showClose: boolean;
  showMiniEventList: boolean;
  showEventSelection: boolean;
  maxEventSelection: number;
  showCopyToResource: boolean;
  showAddButton: boolean;
  showAddReportButton: boolean;
  queryParams: string;
  showDataCaptureSection: boolean;
  nlpConfiguration: INLPHighlightConfig;
  showEventList: boolean;
  filters:{
    basedOnDate:boolean;
    considerWorkflow:any
  };
  forceClear: boolean;
  showUpdateButton: boolean;
  permitOnlyAssignee: boolean;
  showNewAddButton: boolean;
  includeDiagnosticOrderContext: boolean;
  readOnlyMode?: boolean;
  showDisclaimer?:boolean;
}

export enum TimelineMarkerType {
  CIRCLE = 'circle',
  SQUARE = 'square',
  CHIP = 'chip'
}

export enum TimelineMarkerFill {
  SOLID = 'solid',
  HALLOW = 'hallow'
}
export enum TimelineGroupBy {
  MONTH = 'month',
  DAY = 'day',
  EVENT_CATEGORY = 'category'
}
export enum TimelineEventActions {
  EVENT_PANEL = 'open_event',
  IMAGES_PANEL = 'open_images',
  VIDEOS_PANEL = 'open_videos',
  CONTEXT_LAUNCH = 'open_context',

}

